import { memo, useCallback, useState } from "react";
import Modal from "components/shared/modal";
import SearchForm from "components/form-generator/search-form/search-form";
import { createSearchParams, useSearchParams } from "react-router-dom";
import { urlDecoder, urlEncoder } from "utils";

const Searchbox = ({ fields }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState(searchParams.get("key") ? urlDecoder(searchParams.get("key")) : "");

    const closeModal = useCallback(() => {
        setShowModal(false);
    }, [])

    const submitHandler = e => {
        e.preventDefault();
        const newSearchParams = createSearchParams(searchParams.toString());

        if (value.length)
            newSearchParams.set("key", urlEncoder(value));
        else
            newSearchParams.delete("key");

        newSearchParams.delete("offset");
        setSearchParams(newSearchParams);
    }

    return (
        <>
            <div className="searchbox-c1">
                <form onSubmit={submitHandler}>
                    <div className="flex h-10 field">
                        <input
                            type="text"
                            className="tp-23 rounded-tr-md rounded-br-md text-sm px-4 w-44 focus:w-72 transition-all"
                            placeholder="جستجو ..."
                            value={value}
                            onChange={e => setValue(e.target.value)}
                        />

                        <button
                            type="button"
                            className="h-10 w-10 bg-primary-100 rounded-tl-md rounded-bl-md text-white fit-center hover:bg-primary-200 transition-colors"
                            onClick={() => setShowModal(true)}
                        >
                            <i className="fa-solid fa-filter"></i>
                        </button>
                    </div>
                </form>
            </div>

            <Modal show={showModal} title="فیلتر ها" closeHandler={closeModal} className="search-modal">
                <SearchForm fields={fields} doneCallback={closeModal} />
            </Modal>
        </>
    )
}

export default memo(Searchbox);   